<template>
  <div class="admin d-flex">
    <sidebar />
    <div class="left"></div>
    <div class="right">
      <div class="container" :class="$route.name">
        <adminHeader />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/admin/sidebar.vue";
import adminHeader from "@/components/admin/admin-header.vue";

export default {
  components: {
    sidebar,
    adminHeader,
  },
  methods: {
    async getTagsAndCategories() {
      //Get tags
      let args = {
        collectionName: "tags",
      };
      let result = await this.$db.getCollection(args);
      this.$store.commit("setTags", result.docs);

      //Get categories
      args = {
        collectionName: "categories",
      };
      result = await this.$db.getCollection(args);
      this.$store.commit("setCategories", result.docs);
    },
  },
  mounted() {
    this.getTagsAndCategories();
  },
};
</script>

<style lang="scss" scoped>
.admin {
  background: #e8eaed;
}
.left {
  width: var(--admin-sidebar-width);
  min-width: var(--admin-sidebar-width);
  @media (max-width: 991px) {
    display: none;
  }
}
.right {
  padding: 20px 40px;

  max-width: calc(100% - var(--admin-sidebar-width));
  @media (max-width: 991px) {
    padding: 20px 0px;
    max-width: 100%;
  }
  flex-grow: 3;
  min-height: 100vh;
}
.container {
  &.funnels {
    max-width: calc(100% - 30px);
  }
}
</style>
